module.exports = __webpack_public_path__ + "img/22.e8ae6075.png";